import { shouldHideAddressSection, findUpstreamAddress } from '../../../utils/addressSharing';

type Translate = (key: string) => string;
type GetStepData = (id: string) => any;

// Form-field element ids (used to scroll to the first error), keyed by validation error key.
export const RBV_ERROR_FIELD_IDS: Record<string, string> = {
  BA_PCODE: 'postcode',
  BA_HUISNR: 'huisnr',
  BA_STRAAT: 'straat',
  VK_GEZSAMST: 'gezsamst',
};

// Validate the address + family composition. Returns a (possibly empty) error map. When the
// address inputs are hidden because an upstream product already supplied the address, fall back
// to that upstream BA so validation doesn't fail on fields the user can't see/fix here.
export function validateRechtsbijstand(
  data: any,
  selectedProducts: any,
  getStepData: GetStepData,
  t: Translate,
): Record<string, string> {
  const errors: Record<string, string> = {};

  const addressHidden = shouldHideAddressSection('rechtsbijstand', selectedProducts, getStepData);
  const localBa = data?.Contractdocument?.PP?.BA;
  const ba = addressHidden
    ? (localBa?.BA_STRAAT ? localBa : (findUpstreamAddress(getStepData, 'rechtsbijstand') || localBa))
    : localBa;
  const vk = data?.Contractdocument?.PP?.VK;

  if (!ba?.BA_PCODE) {
    errors.BA_PCODE = t('screens.rechtsbijstand.validation.postalCodeRequired');
  } else if (!/^[0-9]{4}\s?[A-Z]{2}$/i.test(ba.BA_PCODE)) {
    errors.BA_PCODE = t('screens.rechtsbijstand.validation.invalidPostcode');
  }
  if (!ba?.BA_HUISNR || String(ba.BA_HUISNR).trim() === '') {
    errors.BA_HUISNR = t('screens.rechtsbijstand.validation.houseNumberRequired');
  }
  if (!ba?.BA_STRAAT || !ba?.BA_PLAATS) {
    errors.BA_STRAAT = t('screens.rechtsbijstand.validation.addressNotValidated');
  }
  if (!vk?.VK_GEZSAMST) {
    errors.VK_GEZSAMST = t('screens.rechtsbijstand.validation.familyCompositionRequired');
  }

  return errors;
}

// Scroll the first errored field into view and focus it; falls back to scrolling to top.
export function scrollToFirstError(errors: Record<string, string>): void {
  for (const errorKey of Object.keys(errors)) {
    const elementId = RBV_ERROR_FIELD_IDS[errorKey];
    const element = elementId ? document.getElementById(elementId) : null;
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => element.focus(), 300);
      return;
    }
  }
  window.scrollTo({ top: 0, behavior: 'smooth' });
}
